import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { signInModule } from './modules/signin';

// Other plugins (auth, catalog-graph, techdocs, scaffolder, search, org, user-settings ...) are discovered from
// packages/app/package.json via `app.packages: all` in app-config.yaml (new frontend system feature discovery).
export default createApp({
  features: [catalogPlugin, navModule, homeModule, signInModule],
});
